import react from "react";

const TextArea = ({ label = "", value = "", className = "form-control form-input", errors = [], ...props }) => {
    let randForId = "fild-"+Math.random();
    const hasError = !errors[props.name] ? "" : "is-invalid"
    const ErrorDialog = () => {
        return !errors[props.name] ? <></> :
         (
           <div className="invalid-feedback">
               {errors[props.name][0]}
           </div>
        )
    }

    return (
        <div>
            <label htmlFor={randForId} className="form-label">{label}</label>
            <textarea  id={randForId} className={`${className} ${hasError}`} {...props} value={value === null ? '' : value} >{value === null ? '' : value}</textarea>
            <ErrorDialog />
        </div>
    )
}

export default TextArea;